import { Button, Dialog, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, InputLabel, makeStyles, Menu, MenuItem, Paper, Select, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { DatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/styles";
import clsx from 'clsx';
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import { format } from "date-fns";
import { useFormik } from "formik";
import { boiDepartmentId } from "libs/configs/constant";
import { getErrorMessage, isError } from "libs/utils/form";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeList } from "redux/modules/employeeSlice";
import { addSurrogates, getSurrogates } from "redux/modules/surrogateSlice";
import * as yup from "yup";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  warpDialog: {

    padding: "30px", minWidth: "600px", minHeight: "200px"
  },
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  content: {
    marginTop: 30
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex", justifyContent: "space-between", alignItems: "center"
  },
  buttonDialogSave: {
    width: '100%',
    margin: '15px 5px'
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: '#F1F3F9',
    color: '#8898AA',
    textAlign: 'center'
  },

  warpButtonDetail: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  center: {
    textAlign: 'center'
  },
  btnActive: {
    color: '#2DCE98',
    border: '1px solid #2DCE98',
    backgroundColor: ' white',
    marginRight: 10,
    width: 75
  },
  btnInActive: {
    color: '#F53C56',
    border: '1px solid #F53C56',
    backgroundColor: ' white',
    marginRight: 10,
    width: 75
  },
  dtitle: {
    color: '#40B8D4',
  },
  d2title: {
    color: '#172B4D',
    paddingBottom: 10

  },
  textDialog: {
    width: '100%',
  },
  warpButtonDialogSave: {
    display: 'flex'
  },
  warpRowDialog: {
    marginTop: 10
  },
  warpRowDateDialog: {
    display: 'flex'
  },
  formControl: {
    width: '100%'
  },
  warpFormControl: {
    paddingLeft: 10,
    paddingRight: 10
  },
  buttonStatusDetail: {
    cursor: 'pointer'
  }
}));


function SurrogatePage() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [surrogateSelected, setSurrogateSelected] = React.useState({});
  const [dialogData, setDialogData] = React.useState({});
  const { list: surrogates } = useSelector((state) => state.surrogate);
  useEffect(async () => {
    const body = {
      departmentId: boiDepartmentId
    }

    await getSurrogatesList();
    await dispatch(getEmployeeList(body));
  }, []);




  const handleAddSurrogate = (value) => {

    setDialogData({
      surrogateId: null,
      empId: null,
      startDate: null,
      endDate: null,
    })
    setOpen(true);
  }


  const handleClose = async (value) => {
    if (value) {
      const body = {
        surrogateId: value.surrogateId || null,
        empId: value.empId,
        startDate: value.startDate,
        endDate: value.endDate,
        isActivated: false,
        status: true,
      }
      await dispatch(addSurrogates([body]));
      await getSurrogatesList();
    }
    setOpen(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);

  const getSurrogatesList = async () => {
    await dispatch(getSurrogates());
  }


  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="จัดการผู้รักษาการแทน" />
      <ConfigDialog data={dialogData} open={open} onClose={handleClose} />
      <div className={classes.warpSubHeader} >
        <AdminTitle2 subTitle="ผู้รักษาการแทน" />

        <div>
          <Button variant="contained" size="medium" color="primary" onClick={() => handleAddSurrogate()} className={classes.buttonDialogSave}>
            <AddIcon />
            เพิ่มผู้รักษาการแทน
          </Button>
        </div>

      </div>
      <div className={classes.content}>
        <div className={classes.warpData}>
          <TableContainer>
            <Table className={classes.table} aria-label="customized table">
              <TableHead >
                <TableRow>
                  <StyledTableCell className={classes.tableHead}>#</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>First Name</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Last Name</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Position</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Start Date</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>End Date</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                {surrogates.map((row, index) => (
                  <StyledTableRow key={row.name}>
                    <StyledTableCell component="th" scope="row" className={classes.center}> {index + 1}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row?.firstName}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row?.lastName}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row?.position}</StyledTableCell>
                    <StyledTableCell className={classes.center}>
                      {row.startDate ? format(new Date(row.startDate), "yyyy-MM-dd") : null}
                    </StyledTableCell>
                    <StyledTableCell className={classes.center}>
                      {row.endDate ? format(new Date(row.endDate), "yyyy-MM-dd") : null}
                    </StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center' }}>
                      <div className={classes.warpButtonDetail}>
                        <Switch
                          checked={row?.isActivated}
                          onChange={async (event) => {
                            const body = {
                              surrogateId: row?.surrogateId || null,
                              empId: row?.empId,
                              startDate: row?.startDate,
                              endDate: row?.endDate,
                              isActivated: !row?.isActivated,
                              status: true,
                            }
                            await dispatch(addSurrogates([body]));
                            await getSurrogatesList();
                          }}
                        />
                        <MoreVertIcon className={classes.buttonStatusDetail} onClick={(event) => {
                          setSurrogateSelected(row);
                          setAnchorEl(event.currentTarget);
                        }} />


                      </div>
                    </StyledTableCell>

                  </StyledTableRow>
                ))}

              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={openMenu}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        <MenuItem onClick={() => {
          console.log(surrogateSelected);
          setDialogData({
            surrogateId: surrogateSelected?.surrogateId,
            empId: surrogateSelected?.empId,
            startDate: surrogateSelected?.startDate,
            endDate: surrogateSelected?.endDate,
          })
          setAnchorEl(null);
          setOpen(true);
        }}>
          แก้ไข
        </MenuItem>
        <MenuItem onClick={async () => {
          if (!window.confirm('Do you want to delete this employee?')) { return; }
          const body = {
            surrogateId: surrogateSelected?.surrogateId || null,
            empId: surrogateSelected?.empId,
            startDate: surrogateSelected?.startDate,
            endDate: surrogateSelected?.endDate,
            isActivated: surrogateSelected?.isActivated,
            status: false,
          }
          await dispatch(addSurrogates([body]));
          await getSurrogatesList();
          setAnchorEl(null);

        }}>
          ลบพนักงาน
        </MenuItem>
        <MenuItem onClick={async () => {
          const body = {
            surrogateId: surrogateSelected?.surrogateId || null,
            empId: surrogateSelected?.empId,
            startDate: null,
            endDate: null,
            isActivated: surrogateSelected?.isActivated,
            status: true,
          }
          await dispatch(addSurrogates([body]));
          await getSurrogatesList();
          setAnchorEl(null);
        }}>
          ไม่กำหนดเวลา
        </MenuItem>
        {/* {options.map((option) => (
          <MenuItem key={option} selected={option === 'Pyxis'} onClick={() => {
            setAnchorEl(null);
          }}>
            {option}
          </MenuItem>
        ))} */}
      </Menu>
    </Paper >
  );
}

export default SurrogatePage;



function ConfigDialog(props) {
  const useStylesHoliday = makeStyles((theme) => ({

    warpRowDialog: {
      marginTop: 10
    },
    dtitle: {
      color: '#40B8D4',
    },
    d2title: {
      color: '#172B4D',
      paddingBottom: 10

    },
    textDialog: {
      width: '100%',
    },
    warpDialog: {
      padding: "30px", minWidth: "600px", minHeight: "200px"
    },
    formControl: {
      width: '100%'
    },
    warpFormControl: {
      paddingLeft: 10,
      paddingRight: 10,
      marginTop: 10
    },
    warpButtonDialogSave: {
      display: 'flex'
    },
    buttonDialogSave: {
      width: '100%',
      margin: '15px 5px'
    },
    wrapField: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      marginBottom: 5
    },
  }));



  const classes = useStylesHoliday();
  const { onClose, open, data } = props;
  const dispatch = useDispatch();

  const { list: employees } = useSelector((state) => state.employee);


  const validationSchema = yup.object({
    empId: yup.string().required("Employee is required.")
    // startDate: yup.date().required("Date is required."),
    // remark: yup.string().required("Holiday name is required."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      empId: data?.empId,
      startDate: data?.startDate,
      endDate: data?.endDate,
    },
    onSubmit: async (values) => {

      const body = {
        surrogateId: data?.surrogateId,
        startDate: (values.startDate) ? format(new Date(values.startDate), "yyyy-MM-dd") : null,
        endDate: (values.endDate) ? format(new Date(values.endDate), "yyyy-MM-dd") : null,
        empId: values?.empId
      };

      onClose(body);
    },
  });

  const handleListItemClick = () => {
    onClose({});
  };

  const handleClose = () => {
    onClose();
  };


  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>กำหนดผู้รักษาการแทน</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.warpRowDialog}>
            <Grid container>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <InputLabel className={classes.d2title}>พนักงาน</InputLabel>
              </Grid>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    name="empId"
                    className={classes.root}
                    value={formik.values.empId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("empId", formik)}
                  >
                    {employees
                      .map((v) => v)
                      .sort(sortByName("employeeFistName"))
                      .map((p) => (
                        <MenuItem
                          key={p.empId}
                          value={p.empId}
                        >
                          {p.employeeFistName}    {p.employeeLastName}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText
                    error={isError("empId", formik)}
                  >
                    {getErrorMessage(
                      "empId",
                      formik
                    )}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <div className={clsx(classes.warpRowDialog)}>

            <Grid container>

              <Grid item xs={12} md={6} className={classes.warpFormControl}>

                <div className={classes.wrapField}>
                  <InputLabel className={classes.d2title}>วันที่เริ่มต้น</InputLabel>
                  <DatePicker
                    className={classes.formControl}
                    inputVariant="outlined"
                    openTo="year"
                    format="DD-MM-YYYY"
                    views={["year", "month", "date"]}
                    name={`startDate`}
                    value={formik.values?.startDate || null}
                    onChange={(date) => {
                      formik.setFieldValue(
                        "startDate",
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError("startDate", formik)}
                    helperText={getErrorMessage("startDate", formik)}

                  />
                </div>
              </Grid>
              <Grid item xs={12} md={6} className={classes.warpFormControl}>

                <div className={classes.wrapField}>
                  <InputLabel className={classes.d2title}>วันที่สิ้นสุด</InputLabel>
                  <DatePicker
                    className={classes.formControl}
                    inputVariant="outlined"
                    openTo="year"
                    format="DD-MM-YYYY"
                    views={["year", "month", "date"]}
                    name={`endDate`}
                    value={formik.values?.endDate || null}
                    onChange={(date) => {
                      formik.setFieldValue(
                        "endDate",
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError("endDate", formik)}
                    helperText={getErrorMessage("endDate", formik)}

                  />
                </div>
              </Grid>
            </Grid>
          </div>


          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button variant="outlined" size="medium" type="button" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
                  Close
                </Button>
                <Button variant="contained" size="medium" type="submit" color="primary" className={classes.buttonDialogSave}>
                  Save
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog >
  );
}


function sortByName(fileName) {
  return (a, b) => {
    const nameA = a[fileName]?.toUpperCase(); // ignore upper and lowercase
    const nameB = b[fileName]?.toUpperCase(); // ignore upper and lowercase

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  };
}